// Notification sound utility for Kitchen Portal
// Uses Web Audio API for a pleasant chime sound

export const playNotificationSound = () => {
  try {
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    // Create a pleasant two-tone chime
    const playTone = (frequency, startTime, duration) => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';
      
      // Envelope for smooth sound
      gainNode.gain.setValueAtTime(0, startTime);
      gainNode.gain.linearRampToValueAtTime(0.3, startTime + 0.05);
      gainNode.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
      
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };
    
    const now = audioContext.currentTime;
    
    // Play a pleasant two-note chime (C5 and E5)
    playTone(523.25, now, 0.3);      // C5
    playTone(659.25, now + 0.15, 0.4); // E5
    
  } catch (error) {
    console.log('Audio notification not supported:', error);
  }
};

// Check if sound is enabled (stored in localStorage)
export const isSoundEnabled = () => {
  return localStorage.getItem('kitchenSoundEnabled') !== 'false';
};

// Toggle sound setting
export const toggleSound = () => {
  const currentSetting = isSoundEnabled();
  localStorage.setItem('kitchenSoundEnabled', (!currentSetting).toString());
  return !currentSetting;
};
